﻿import React from 'react';
import type { PaddingOptions } from 'maplibre-gl';

const DEFAULT: PaddingOptions = { top: 10, right: 10, bottom: 10, left: 10 };
// Gives info about opened flyouts, for encompass purposes
export const MapPaddingContext = React.createContext<PaddingOptions>(DEFAULT);

